<template>
  <div>
    <el-select
    class="toilet-select"
    v-show="options.length > 0" :style="{width: width || '100%'}"
      v-model="form.toiletId"
      filterable
      remote
      reserve-keyword
      placeholder="请选择厕所"
      @change="select"
      @clear="clear"
    >
      <el-option
        v-for="item in options"
        :key="item.value"
        :label="item.label"
        :value="parseInt(item.value)"
      >
      </el-option>
    </el-select>
    <el-select v-show="options.length  == 0"
    class="toilet-select"
    :style="{width: width || '100%'}" 
    placeholder="请选择厕所"
    v-model="defaultName"></el-select>
  </div>
</template>

<script>

export default {
  name: "ToiletSelect",
  props: ["toiletId", "toiletType", "width"],
  data() {
    return {
      options: [],
      form: {
        toiletId: null,
      },
      defaultName: null,
      data: [],
    };
  },
  created() {
    this.getOptions();
  },
  methods: {
    getOptions() {
      if(!this.toiletType) {
        return;
      }
      this.data = [];
      this.get("toiletInfo/list", { toiletType: this.toiletType, isQueryAll: false }).then(res => {
        this.data = res.data.rows;
        this.options = Array.prototype.reverse.call(res.data.rows).map((item) => {
          return {
            value: `${item.id}`,
            label: `${item.name}`,
          };
        });
      });
    },
    select(e) {
      this.$emit("getId", e);
      this.data.forEach(item => {
        if(item.id == e) {
          this.$emit("getData", item);
        }
      });
    },
    clear(e) {
      this.getOptions();
      this.$emit("getId", e);
    },
  },
  watch: {
    toiletId: {
      handler() {
        this.form.toiletId = this.toiletId;
      },
      immediate: true, //立即执行
    },
  },
};
</script>

<style scoped>
.toilet-select {
  margin-left: 5px;
  border-radius: 5px;
  border: 2px solid rgb(69, 162, 255);
}
</style>



// WEBPACK FOOTER //
// src/components/html/toiletSelect.vue